const styles = require("@fortawesome/fontawesome-svg-core/styles.css");
const config = require("@fortawesome/fontawesome-svg-core");
config.autoAddCss = false;

import { RootElementWrapper } from "./src/components";

export const wrapRootElement = RootElementWrapper;
